module.exports = __webpack_public_path__ + "img/5.571cf3ad.png";